import OrthographicView from '../../views/orthographic-view';
import WebMercatorViewport from '../../viewports/web-mercator-viewport';
import { fitBounds } from '@math.gl/web-mercator';
export function getMaskBounds({
  layers,
  viewport
}) {
  let bounds = null;

  for (const layer of layers) {
    const subLayerBounds = layer.getBounds();

    if (subLayerBounds) {
      if (bounds) {
        bounds[0] = Math.min(bounds[0], subLayerBounds[0][0]);
        bounds[1] = Math.min(bounds[1], subLayerBounds[0][1]);
        bounds[2] = Math.max(bounds[2], subLayerBounds[1][0]);
        bounds[3] = Math.max(bounds[3], subLayerBounds[1][1]);
      } else {
        bounds = [subLayerBounds[0][0], subLayerBounds[0][1], subLayerBounds[1][0], subLayerBounds[1][1]];
      }
    }
  }

  const viewportBounds = viewport.getBounds();

  if (!bounds) {
    return viewportBounds;
  }

  const paddedBounds = _doubleBounds(viewportBounds);

  if (bounds[2] - bounds[0] < paddedBounds[2] - paddedBounds[0] || bounds[3] - bounds[1] < paddedBounds[3] - paddedBounds[1]) {
    return bounds;
  }

  bounds[0] = Math.max(bounds[0], paddedBounds[0]);
  bounds[1] = Math.max(bounds[1], paddedBounds[1]);
  bounds[2] = Math.min(bounds[2], paddedBounds[2]);
  bounds[3] = Math.min(bounds[3], paddedBounds[3]);
  return bounds;
}
export function getMaskViewport({
  bounds,
  viewport,
  width,
  height
}) {
  if (bounds[2] <= bounds[0] || bounds[3] <= bounds[1]) {
    return null;
  }

  const padding = 1;
  width -= padding * 2;
  height -= padding * 2;

  if (viewport instanceof WebMercatorViewport) {
    const {
      longitude,
      latitude,
      zoom
    } = fitBounds({
      width,
      height,
      bounds: [[bounds[0], bounds[1]], [bounds[2], bounds[3]]],
      maxZoom: 20
    });
    return new WebMercatorViewport({
      longitude,
      latitude,
      zoom,
      x: padding,
      y: padding,
      width,
      height
    });
  }

  const center = [(bounds[0] + bounds[2]) / 2, (bounds[1] + bounds[3]) / 2, 0];
  const scale = Math.min(20, width / (bounds[2] - bounds[0]), height / (bounds[3] - bounds[1]));
  return new OrthographicView({
    x: padding,
    y: padding
  }).makeViewport({
    width,
    height,
    viewState: {
      target: center,
      zoom: Math.log2(scale)
    }
  });
}

function _doubleBounds(bounds) {
  const size = {
    x: bounds[2] - bounds[0],
    y: bounds[3] - bounds[1]
  };
  const center = {
    x: bounds[0] + 0.5 * size.x,
    y: bounds[1] + 0.5 * size.y
  };
  return [center.x - size.x, center.y - size.y, center.x + size.x, center.y + size.y];
}
//# sourceMappingURL=utils.js.map